export {parseTime, formatTime} from "@/utils"
export function getShopColor(val) {
	return val == "XSZ"
		? {background: "rgba(29, 32, 137, 1)"}
		: {background: "rgba(0, 186, 173, 1)"}
}
export function getLevelColor(val) {
	switch (val) {
		// a级#0189b7   b级#ffbd02  c级#7C61F2
		case "A":
			return {background: "#FE7648"}

		// return {background: "#0189b7"}
		case "B":
			return {background: "#ffbd02"}
		case "C":
			return {background: "#7C61F2"}

		// case "A":
		//   return { background: "rgba(254, 118, 72, 1)" };
		// case "B":
		//   return { background: "rgba(255, 189, 2, 1)" };
		// case "C":
		//   return { background: "rgba(124, 97, 242, 1)" };
	}
}
